import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { translate } from '../../../base/i18n/functions';
import { IconVolumeUp } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { toggleNkfMakeupGain } from '../../actions';
import { isNkfMakeupGainOn } from '../../functions';
/**
 * 音量の自動調整(メイクアップゲイン)を入切するツールバー項目。
 *
 * AEC とノイズ抑制の後段で、送信音の音量を目標(≈ -18 dBFS)へ緩やかに寄せる
 * 段がある。小声の人には要るが、環境によっては動きすぎて不自然に聞こえるので
 * 通話中に切れるようにしてある。
 *
 * 切ってもリミッターは残る。求められているのは音量が勝手に動かないことであって、
 * 歪んでよいという意味ではない。
 */
class NkfMakeupGainButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityNkfMakeupGain';
    icon = IconVolumeUp;
    label = 'toolbar.nkfMakeupGainOff';
    toggledLabel = 'toolbar.nkfMakeupGain';
    tooltip = 'toolbar.nkfMakeupGain';
    /**
     * 自動調整を切り替える。
     *
     * @override
     * @protected
     * @returns {void}
     */
    _handleClick() {
        const { _on, dispatch } = this.props;
        sendAnalytics(createToolbarEvent('nkf.makeupgain', { enable: !_on }));
        dispatch(toggleNkfMakeupGain());
    }
    /**
     * 自動調整が有効な間トグル(ON)。
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._on;
    }
}
/**
 * Maps part of the redux state to the component's props.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    return {
        _on: isNkfMakeupGainOn(state)
    };
}
export default translate(connect(mapStateToProps)(NkfMakeupGainButton));
